import VisibilityCard, {
  VisibilityCardProps
} from "@saleor/components/VisibilityCard";
import useDateLocalize from "@saleor/hooks/useDateLocalize";
import { joinDateTime } from "@saleor/misc";
import React from "react";
import { useIntl } from "react-intl";

interface AvailabilityCardProps extends VisibilityCardProps {
  data: {
    availableForPurchaseDate: string;
    availableForPurchaseTime: string;
    isAvailableForPurchase: boolean;
    isPublished: boolean;
    publicationDate: string;
    visibleInListings: boolean;
    preOrderDate: string;
    preOrderTime: string;
  };
}

export const AvailabilityCard: React.FC<AvailabilityCardProps> = props => {
  const intl = useIntl();
  const localizeDate = useDateLocalize();

  return (
    <VisibilityCard
      {...props}
      messages={{
        ...props.messages,
        availableLabel: intl.formatMessage({
          defaultMessage: "Available for purchase",
          description: "product availability"
        }),
        availableSecondLabel: intl.formatMessage(
          {
            defaultMessage: "will become available on {date}",
            description: "product available for purchase date"
          },
          {
            date: localizeDate(
              joinDateTime(
                props.data.availableForPurchaseDate,
                props.data.availableForPurchaseTime
              ),
              "DD/MM/YYYY HH:mm"
            )
          }
        ),
        setAvailabilityDateLabel: intl.formatMessage({
          defaultMessage: "Set availability date",
          description: "product availability date label"
        }),
        unavailableLabel: intl.formatMessage({
          defaultMessage: "Unavailable for purchase",
          description: "product unavailability"
        }),
        preOrderLabel: intl.formatMessage({
          defaultMessage: "Preorder"
        }),
        preOrderSecondLabel: intl.formatMessage(
          {
            defaultMessage: "will arrival on {date}"
          },
          {
            date: localizeDate(
              joinDateTime(props.data.preOrderDate, props.data.preOrderTime),
              "DD/MM/YYYY HH:mm"
            )
          }
        ),
        setPreOrderDateLabel: intl.formatMessage({
          defaultMessage: "Set preorder date"
        }),
        unPreOrderLabel: intl.formatMessage({
          defaultMessage: "Not preorder"
        })
      }}
    />
  );
};

export default AvailabilityCard;
